import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/* eslint-disable @typescript-eslint/no-explicit-any */
// Validator to check if current number value is less than or greater than matched number value
// Must add to at least two controls in order to be able to compare
export function compareNumberLesserGreaterValidator(
    matchTo: string,
    comparison: 'less than' | 'greater than'
): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const parentValue = control.parent?.get(matchTo)?.value;

        const valueNumber = control.value ? parseFloat(control?.value) : null;
        const comparedToNumber = parentValue ? parseFloat(parentValue) : null;

        if (valueNumber !== null && comparedToNumber !== null) {
            if (comparison === 'less than') {
                return valueNumber < comparedToNumber ? null : { lessThan: true };
            } else {
                return valueNumber > comparedToNumber ? null : { greaterThan: true };
            }
        }

        return null;
    };
}
